import { Link } from "react-router-dom";

export default function ReturnsPage() {
  return (
    <div className="pt-28 lg:pt-44 pb-16" data-testid="returns-page">
      <section className="max-w-3xl mx-auto px-6">
        <p className="font-accent text-xl text-sunset mb-1">no worries</p>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight mb-8">Returns</h1>

        <div className="bg-white/70 rounded-2xl border border-black/5 p-7 space-y-5 text-charcoal/75 leading-relaxed">
          <p>
            If you're not completely happy with your purchase, unopened and unused products can be
            returned within 14 days of delivery.
          </p>
          <p>
            Unfortunately, for hygiene reasons, opened products can't be returned unless they're
            faulty.
          </p>
          <p>
            If you're unsure which products are right for your hair, complete{" "}
            <Link to="/curlscan" className="text-olive underline underline-offset-2">The Curl Edit</Link>{" "}
            or <Link to="/work-with-me" className="text-olive underline underline-offset-2">get in touch</Link>{" "}
            before ordering — I'm always happy to help.
          </p>
        </div>
      </section>
    </div>
  );
}
